<template>
    <div class="notification" :class="[notification.type, {fading : fading}]" @click="done()">
        <div class="data">
            <div class="name">{{notification.title}}</div>
            <div class="value">
                <div class="code">{{notification.message | capitalize}}</div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'notification-panel-item',
    props: ['notification'],
    data() {
      return {
        fading: false,
      };
    },

    filters: {
      capitalize(str) {
        if (typeof str === 'string') {
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
      }
    },

    created() {
      this.timer();
      this.$parent.$on('done', this.done);
    },

    methods: {
      timer() {
        setTimeout(() => {
          this.done();
        }, 5000);
      },
      done() {
        this.fading = true;
        setTimeout(() => {
          this.$emit('done');
        }, 300);
      }
    }
  };
</script>

<style scoped lang="scss">
    .notification {
        margin: 1em;
        box-shadow: 1px 1px 50px 5px rgba(0, 0, 0, .4);
        border-radius: 0.2em;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        animation: NotifSlideUp .3s ease-in-out forwards;
        position: relative;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    }

    .notification .name {
        font-weight: 700;
        color: #fff;
        text-transform: uppercase;
        font-size: 0.8em;
        padding: 15px 30px 0 25px;
    }

    .notification.Logged.in .name, .notification.success .name {
        color: #16b029;
    }

    .notification.error .name {
        color: #ff7c7c
    }

    .notification .code {
        white-space: pre-wrap;
        word-wrap: break-word
    }

    .notification .value {
        padding: 8px 30px 15px 25px;
        color: #555;
        font-size: 1em;
        min-width: 80px;
        max-width: 300px;
        font-weight: 500;
    }

    .notification.fading {
        animation: NotifFadeOut .3s ease-in-out forwards
    }

    @keyframes NotifSlideUp {
        from {
            transform: translateX(200px);
            opacity: 0;
        }
        to {
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes NotifFadeOut {
        from {
            opacity: 1
        }
        to {
            opacity: 0
        }
    }
</style>